import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';
import { TimeDimension, SortOrder } from '@/lib/services/watchlist.service';
type DataState = {
  sortedType: TimeDimension;
  honeypotFilter: boolean;
  priceOrder?: SortOrder;
  changeOrder?: SortOrder;
};

const dataInitState: DataState = {
  sortedType: '5m',
  honeypotFilter: true,
};

const tradeSlice = createSlice({
  name: 'data',
  initialState: dataInitState,
  reducers: {
    setTradedSortedType: (state, action: { payload: TimeDimension }) => {
      state.sortedType = action.payload;
    },
    setTradedHoneypotFilter: (state, action: { payload: boolean }) => {
      state.honeypotFilter = action.payload;
    },
    setTradedPriceOrder: (
      state,
      action: PayloadAction<SortOrder | undefined>,
    ) => {
      state.priceOrder = action.payload;
    },
    setTradedChangeOrder: (
      state,
      action: PayloadAction<SortOrder | undefined>,
    ) => {
      state.changeOrder = action.payload;
    },
  },
});

export const reduxTradeSortedType = (state: RootState) =>
  state.trade.sortedType;
export const reduxTradedHoneypotFilter = (state: RootState) =>
  state.trade.honeypotFilter;
export const reduxTradedPriceOrder = (state: RootState) =>
  state.trade.priceOrder;
export const reduxTradedChangeOrder = (state: RootState) =>
  state.trade.changeOrder;

export const {
  setTradedSortedType,
  setTradedHoneypotFilter,
  setTradedPriceOrder,
  setTradedChangeOrder,
} = tradeSlice.actions;
export default tradeSlice.reducer;
